export type JobRecordsGateView = 'wait' | 'crew-list' | 'job-card' | 'office-home';

export function decideJobRecordsGate(args: {
  loading: boolean;
  hasProfile: boolean;
  isSiteCrew: boolean;
  projectId?: string;
}): JobRecordsGateView {
  if (args.loading || !args.hasProfile) return 'wait';
  if (args.isSiteCrew) return args.projectId ? 'job-card' : 'crew-list';
  if (args.projectId) return 'job-card';
  return 'office-home';
}
